import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { PaginatedResponse } from 'app/interfaces/api';
import { UserEntity } from 'app/interfaces/entity';
import { apiRequestCall } from 'app/services/api';
import { ApiResource } from 'app/services/api/enums';
import { cancelationSubscribe } from 'app/services/api/utils';
import { entityStoreStatus } from 'app/utils/store/entity-store-status';
import { SearchUsersStoreStatus } from 'modules/users/store/search-users/enums';
import { SearchUsersState } from 'modules/users/store/search-users/interfaces/search-users-state';

import { entityAdapter } from 'modules/users/store/users/adapter';

export const getSearchUsersList = createAsyncThunk(
  `${EntityStoreName.SearchUsers}/getSearchUsersList`,
  (
    { search, withActiveUser }: { search: string; withActiveUser: boolean },
    { signal }
  ): Promise<PaginatedResponse<UserEntity[]>> => {
    const cancelToken = cancelationSubscribe(signal);

    return apiRequestCall<PaginatedResponse<UserEntity[]>>({
      params: {
        method: 'GET',
        resource: ApiResource.Users,
        cancelToken,
        params: {
          ...(search ? { search } : null),
          withActiveUser,
        },
      },
    });
  }
);

export const clearAllReducer = (state: SearchUsersState): void => {
  entityAdapter.removeAll(state);
};

export const registerReducers = (builder: ActionReducerMapBuilder<SearchUsersState>): void => {
  builder
    .addCase(getSearchUsersList.pending, (state, action) => {
      entityStoreStatus.addRequestId(state, SearchUsersStoreStatus.Loading, action.meta.requestId);
    })
    .addCase(getSearchUsersList.fulfilled, (state, action) => {
      entityAdapter.setAll(state, action.payload.data);
      entityStoreStatus.removeRequestId(
        state,
        SearchUsersStoreStatus.Loading,
        action.meta.requestId
      );
    })
    .addCase(getSearchUsersList.rejected, (state, action) => {
      entityStoreStatus.removeRequestId(
        state,
        SearchUsersStoreStatus.Loading,
        action.meta.requestId
      );
    });
};
